/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AcquisitionAnalyticsResponseDto } from '../model/acquisition-analytics-response-dto';
// @ts-ignore
import { AnalyticsSegmentDto } from '../model/analytics-segment-dto';
// @ts-ignore
import { CampaignDetailAnalyticsResponseDto } from '../model/campaign-detail-analytics-response-dto';
// @ts-ignore
import { CampaignsAnalyticsResponseDto } from '../model/campaigns-analytics-response-dto';
// @ts-ignore
import { CohortsAnalyticsResponseDto } from '../model/cohorts-analytics-response-dto';
// @ts-ignore
import { InsightsAnalyticsResponseDto } from '../model/insights-analytics-response-dto';
// @ts-ignore
import { MembersAnalyticsResponseDto } from '../model/members-analytics-response-dto';
// @ts-ignore
import { OverviewAnalyticsResponseDto } from '../model/overview-analytics-response-dto';
// @ts-ignore
import { PassesAnalyticsResponseDto } from '../model/passes-analytics-response-dto';
// @ts-ignore
import { PointsAnalyticsResponseDto } from '../model/points-analytics-response-dto';
// @ts-ignore
import { ProgramAnalytics } from '../model/program-analytics';
// @ts-ignore
import { ProgramAnalyticsAggregate } from '../model/program-analytics-aggregate';
// @ts-ignore
import { RevenueAnalyticsResponseDto } from '../model/revenue-analytics-response-dto';
// @ts-ignore
import { RewardDetailAnalyticsResponseDto } from '../model/reward-detail-analytics-response-dto';
// @ts-ignore
import { RewardsAnalyticsResponseDto } from '../model/rewards-analytics-response-dto';
// @ts-ignore
import { TiersAnalyticsResponseDto } from '../model/tiers-analytics-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    AnalyticsServiceInterface,
    AnalyticsControllerGetAcquisitionAnalyticsV1RequestParams,
    AnalyticsControllerGetAnalyticsAggregateV1RequestParams,
    AnalyticsControllerGetAnalyticsV1RequestParams,
    AnalyticsControllerGetCampaignDetailAnalyticsV1RequestParams,
    AnalyticsControllerGetCampaignsAnalyticsV1RequestParams,
    AnalyticsControllerGetCohortsAnalyticsV1RequestParams,
    AnalyticsControllerGetInsightsAnalyticsV1RequestParams,
    AnalyticsControllerGetMembersAnalyticsV1RequestParams,
    AnalyticsControllerGetOverviewAnalyticsV1RequestParams,
    AnalyticsControllerGetPassesAnalyticsV1RequestParams,
    AnalyticsControllerGetPointsAnalyticsV1RequestParams,
    AnalyticsControllerGetRevenueAnalyticsV1RequestParams,
    AnalyticsControllerGetRewardDetailAnalyticsV1RequestParams,
    AnalyticsControllerGetRewardsAnalyticsV1RequestParams,
    AnalyticsControllerGetSegmentsAnalyticsV1RequestParams,
    AnalyticsControllerGetTiersAnalyticsV1RequestParams
} from './analytics.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class AnalyticsService extends BaseService implements AnalyticsServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get webapp acquisition and conversion
     * Interpretation: this is a period activity ratio, not a visitor-to-installer cohort probability; it can exceed 100%. The top 20 sources need not add up to the program total. Zero views returns a zero ratio by convention, not evidence of measured conversion. The signup, installation and purchase stages form an ordered customer cohort within the selected period. Visits are all period visit records, not individually linked to that cohort; do not interpret visits-to-signups as a tracked visitor conversion probability.  Counts visit records (page views, not unique visitors) and customer activations: the first installed store card after having none. Further passes or wallets for the same active customer are not additional installations. Coupon installations and customerless passes are excluded. Conversion is installs/pageViews, expressed as a fraction and zero when there are no views. Sources prefer pass tracking, then the latest preceding customer visit; missing sources become direct. Returns the top 20 source/campaign pairs by installs and an OS breakdown.  The funnel starts with JERICOMMERCE-origin customers created in the requested period. passInstalled counts each customer once using the earliest recorded store-card installed_at on or after signup and on or before to_date. firstPurchase counts those customers with a processed non-return purchase on or after that installation and on or before to_date; it does not require their first-ever purchase. Repeated passes and purchases do not increase the customer count. Boundaries are inclusive, including equal timestamps. KPI previous values follow compare; this is not a cohort conversion rate for every visitor.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/acquisition
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetAcquisitionAnalyticsV1(requestParameters: AnalyticsControllerGetAcquisitionAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AcquisitionAnalyticsResponseDto>;
    public analyticsControllerGetAcquisitionAnalyticsV1(requestParameters: AnalyticsControllerGetAcquisitionAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AcquisitionAnalyticsResponseDto>>;
    public analyticsControllerGetAcquisitionAnalyticsV1(requestParameters: AnalyticsControllerGetAcquisitionAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AcquisitionAnalyticsResponseDto>>;
    public analyticsControllerGetAcquisitionAnalyticsV1(requestParameters: AnalyticsControllerGetAcquisitionAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetAcquisitionAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/acquisition`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AcquisitionAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a legacy daily series by platform
     * Returns the selected information metric as daily Apple, Google and other counts in installedByDay, regardless of the selected metric. Missing days are filled with zero. PASSES_INSTALLED and PUSHES_SENT use customer events; CLICKS uses click records; WEBAPP_VIEWS deduplicates visits by customer and database calendar day.  campaign_id is supported for CLICKS and PUSHES_SENT. Combining it with PASSES_INSTALLED or WEBAPP_VIEWS returns HTTP 400. PUSHES_SENT counts push events, not device delivery timestamps.  Uses the legacy date parser and server/database time zones; X-APP-TIMEZONE does not affect the series. No previous-period comparison or automatic anonymous-campaign exclusion is applied.
     * @endpoint get /v1/analytics/{programId}/analytics/aggregate
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetAnalyticsAggregateV1(requestParameters: AnalyticsControllerGetAnalyticsAggregateV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProgramAnalyticsAggregate>;
    public analyticsControllerGetAnalyticsAggregateV1(requestParameters: AnalyticsControllerGetAnalyticsAggregateV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProgramAnalyticsAggregate>>;
    public analyticsControllerGetAnalyticsAggregateV1(requestParameters: AnalyticsControllerGetAnalyticsAggregateV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProgramAnalyticsAggregate>>;
    public analyticsControllerGetAnalyticsAggregateV1(requestParameters: AnalyticsControllerGetAnalyticsAggregateV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const fromDate = requestParameters?.fromDate;
        if (fromDate === null || fromDate === undefined) {
            throw new Error('Required parameter fromDate was null or undefined when calling analyticsControllerGetAnalyticsAggregateV1.');
        }
        const toDate = requestParameters?.toDate;
        if (toDate === null || toDate === undefined) {
            throw new Error('Required parameter toDate was null or undefined when calling analyticsControllerGetAnalyticsAggregateV1.');
        }
        const information = requestParameters?.information;
        if (information === null || information === undefined) {
            throw new Error('Required parameter information was null or undefined when calling analyticsControllerGetAnalyticsAggregateV1.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetAnalyticsAggregateV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const campaignId = requestParameters?.campaignId;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'information',
            <any>information,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'campaign_id',
            <any>campaignId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/analytics/aggregate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProgramAnalyticsAggregate>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get legacy analytics counters by platform
     * Counts PASS_INSTALLED events, clicks, notifications and web visits for the program, split by Apple, Google and other platforms. Web visits are deduplicated by customer and database calendar day, including a shared group for visits without a customer.  Notifications use created_at and only passes currently marked installed. This measures notification creation, unlike the dashboard campaign endpoints which use device delivery (sent_at). campaign_id filters clicks and notifications; pass and web-visit counters are zero when it is supplied.  Uses the legacy date parser and server/database time zones; X-APP-TIMEZONE does not affect these counters. No previous-period comparison or automatic anonymous-campaign exclusion is applied.
     * @endpoint get /v1/analytics/{programId}/analytics
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetAnalyticsV1(requestParameters: AnalyticsControllerGetAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProgramAnalytics>;
    public analyticsControllerGetAnalyticsV1(requestParameters: AnalyticsControllerGetAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProgramAnalytics>>;
    public analyticsControllerGetAnalyticsV1(requestParameters: AnalyticsControllerGetAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProgramAnalytics>>;
    public analyticsControllerGetAnalyticsV1(requestParameters: AnalyticsControllerGetAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const fromDate = requestParameters?.fromDate;
        if (fromDate === null || fromDate === undefined) {
            throw new Error('Required parameter fromDate was null or undefined when calling analyticsControllerGetAnalyticsV1.');
        }
        const toDate = requestParameters?.toDate;
        if (toDate === null || toDate === undefined) {
            throw new Error('Required parameter toDate was null or undefined when calling analyticsControllerGetAnalyticsV1.');
        }
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const campaignId = requestParameters?.campaignId;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'campaign_id',
            <any>campaignId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/analytics`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProgramAnalytics>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get campaign detail and peer benchmarks
     * Peer limitations: same-type campaigns are not matched for audience size, content or seasonality. benchmarkUniqueClicks scales peer bucket clickers by peer deliveries and the current campaign\&#39;s delivery volume; it is not raw average clicks or a prediction. Unique clickers are deduplicated per bucket and cannot be summed to recover period uniqueClicks. The first-72-hour and first-seven-day charts can cover less time than the KPI window. The seven-day chart since campaign start is distinct from the seven-day click lookback before each purchase.  Attribution limitations: the purchase date must fall in the analysis window, while the last eligible click may be up to seven days earlier, including before from_date. Last-click selection considers all eligible program campaigns. Return transactions are excluded; later refunds do not reduce attributed revenue or order count. No delivery is required. Attribution is an association, not causal lift or incremental sales.  Anonymous campaigns are excluded. An anonymous, deleted or missing campaign returns HTTP 404 CAMPAIGN_NOT_FOUND. A campaign belonging to another program is rejected with HTTP 400 PROGRAM_ID_CAMPAIGN_ID_MISMATCH. Delivery counts use sent_at, excluding undelivered notifications. Unique clicks count customers; attributed purchases use the latest eligible campaign click in the preceding seven days, with revenue in major units of program currency.  KPI previous values use other non-deleted campaigns of the same type with a start date, not the previous date period. Count and revenue benchmarks are arithmetic means; CTR is weighted by peer deliveries, considering clickers from peers with deliveries. Scheduled campaign windows are aligned relative to each campaign start. compare does not control these benchmarks; previousFrom and previousTo are null. Missing peers yield null benchmarks. Metrics requiring a link or audience are null when unavailable.  Scheduled campaigns with startedAt return 24 three-hour buckets covering the first 72 hours and a separate seven-day attributed-revenue series. Other campaigns use calendar buckets at the requested granularity. Pass and coupon-use KPIs are not calculated here and remain null. series.installs is an uncalculated zero placeholder, not a measured installation count.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/campaigns/{campaignId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetCampaignDetailAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignDetailAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CampaignDetailAnalyticsResponseDto>;
    public analyticsControllerGetCampaignDetailAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignDetailAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CampaignDetailAnalyticsResponseDto>>;
    public analyticsControllerGetCampaignDetailAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignDetailAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CampaignDetailAnalyticsResponseDto>>;
    public analyticsControllerGetCampaignDetailAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignDetailAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetCampaignDetailAnalyticsV1.');
        }
        const campaignId = requestParameters?.campaignId;
        if (campaignId === null || campaignId === undefined) {
            throw new Error('Required parameter campaignId was null or undefined when calling analyticsControllerGetCampaignDetailAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/campaigns/${this.configuration.encodeParam({name: "campaignId", value: campaignId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CampaignDetailAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get campaign delivery, engagement and attributed revenue
     * Engagement limitations: uniqueClicks is deduplicated per customer/campaign, not across all campaigns. Click and delivery windows are independent; a clicker need not match a period recipient and CTR can exceed 100%. Delivery is not proof that the user read the notification. The send-time grid uses local delivery time, ISO weekdays and only 08:00-23:00. It matches each period click to the latest preceding delivery for that customer/campaign, with no maximum delay, then retains deliveries in the period. Observed slot CTR has no minimum sample size or controls for audience/content; do not present it as a proven optimal send time.  Attribution limitations: purchases are selected by transaction created_at; the winning click may precede from_date. Last click is selected across all eligible program campaigns, even when campaign_id filters the result. Return transactions are excluded and later refunds do not reduce the original attributed purchase. Delivery is not required for attribution. This is an association, not proof of causal lift, incremental revenue, profit or ROI. Currency conversion uses the local purchase day.  Anonymous campaigns are excluded, as are deleted campaigns. sent counts notifications by sent_at: when the device requests and receives the update. created_at records submission to Apple/Google and is not used for delivery counts. Notifications without sent_at are excluded from sent.  Unique clicks count distinct customers per campaign within the period. Overall CTR is clicks on campaigns with deliveries divided by deliveries, as a fraction (0.1 means 10%), or zero without deliveries. Attributed revenue assigns each processed non-return purchase to the customer\&#39;s latest eligible campaign click within seven days before the purchase, in major units of program currency.  KPIs, type breakdown and send-time grid use all matching campaigns; pagination only affects items. campaign_id restricts the results; an excluded or unknown campaign produces an empty list. Campaigns with no activity can still appear. Comparison KPIs follow compare.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/campaigns
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetCampaignsAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CampaignsAnalyticsResponseDto>;
    public analyticsControllerGetCampaignsAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CampaignsAnalyticsResponseDto>>;
    public analyticsControllerGetCampaignsAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CampaignsAnalyticsResponseDto>>;
    public analyticsControllerGetCampaignsAnalyticsV1(requestParameters: AnalyticsControllerGetCampaignsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetCampaignsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;
        const campaignId = requestParameters?.campaignId;
        const page = requestParameters?.page;
        const limit = requestParameters?.limit;
        const sort = requestParameters?.sort;
        const order = requestParameters?.order;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'campaign_id',
            <any>campaignId,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'page',
            <any>page,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'limit',
            <any>limit,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'sort',
            <any>sort,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'order',
            <any>order,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/campaigns`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CampaignsAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get monthly signup cohorts and subsequent buyers
     * Interpretation: buyersByMonth measures independent monthly purchasing, not consecutive retention, app activity or pass installation. Divide each count by that cohort\&#39;s members only when a percentage is desired. Unelapsed future months are absent, not zero; the first and last months may be partial according to the requested bounds.  Returns monthly signup cohorts from the month containing from_date through the month containing to_date, including empty months. Only signups between the inclusive requested bounds belong to a cohort. Signup date uses loyalty member_since (local midnight), then joined_at, then created_at. Each cohort contains its member count and buyersByMonth: distinct customers with a processed non-return purchase on or after signup, starting with the signup month and ending at to_date.  Buyer values are counts, not retention percentages. Purchases must be on or after the included customer\&#39;s signup and on or before to_date. A partial first month includes only signups on or after from_date; the last month stops at to_date. granularity and compare are validated as range inputs but do not change the monthly grouping or add comparison data. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/cohorts
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetCohortsAnalyticsV1(requestParameters: AnalyticsControllerGetCohortsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CohortsAnalyticsResponseDto>;
    public analyticsControllerGetCohortsAnalyticsV1(requestParameters: AnalyticsControllerGetCohortsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CohortsAnalyticsResponseDto>>;
    public analyticsControllerGetCohortsAnalyticsV1(requestParameters: AnalyticsControllerGetCohortsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CohortsAnalyticsResponseDto>>;
    public analyticsControllerGetCohortsAnalyticsV1(requestParameters: AnalyticsControllerGetCohortsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetCohortsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cohorts`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CohortsAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get actionable dashboard insights
     * Interpretation: these are fixed heuristics, not statistical significance tests, industry benchmarks or predictions. No minimum sample size is enforced. Rate differences in params.change are absolute fractions: 0.05 means five percentage points, not five percent relative growth. Low-volume or incomplete months can trigger rules; severity labels express the rule classification, not confidence.  Returns up to three rule-based insights ordered by severity: serious, warning, good. Uses webapp conversion, monthly customer deactivations across store-card wallets and, when JeriCommerce loyalty is available, redemption rate and referral share. Each insight contains a stable key, numeric parameters and a suggested action for the client to render.  Redemption rates below 13% or above 15%, referral-share changes of at least 5 percentage points, monthly uninstalls above 1.5 times the monthly average, and conversion drops of at least 3 percentage points can trigger insights. Change-based insights require comparison data. An empty array means no rule matched.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.  Known limitation: redemption-rate insights inherit incomplete reward-refund attribution from points analytics; refunds may not be fully reflected in the input rate.
     * @endpoint get /v1/analytics/{programId}/insights
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetInsightsAnalyticsV1(requestParameters: AnalyticsControllerGetInsightsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightsAnalyticsResponseDto>;
    public analyticsControllerGetInsightsAnalyticsV1(requestParameters: AnalyticsControllerGetInsightsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightsAnalyticsResponseDto>>;
    public analyticsControllerGetInsightsAnalyticsV1(requestParameters: AnalyticsControllerGetInsightsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightsAnalyticsResponseDto>>;
    public analyticsControllerGetInsightsAnalyticsV1(requestParameters: AnalyticsControllerGetInsightsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetInsightsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/insights`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightsAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get member growth, purchasing frequency and referrals
     * Interpretation: repeat rate describes purchases within the selected period, not retention of a signup cohort. The top-five referrer ranking matches referral to customer email case-insensitively and excludes self-referrals; unmatched referrals still count in referred growth. Referred revenue is gross period purchase revenue from matched signups, without deducting refunds or enforcing purchase-after-signup ordering. It is not incremental revenue caused by referral.  Includes program customers. Signup date uses loyalty member_since, then joined_at, then created_at. Total members is measured at to_date; new members and referral share use signups within the period. A non-empty referral marks a referred signup.  Buyers and purchase frequency use processed transactions without return_id in the period; repeat rate is customers with at least two purchases divided by buyers. Returns signup sources, organic/referred growth and top referrers. Rates are fractions, monetary values use program currency, and KPI previous values follow compare. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/members
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetMembersAnalyticsV1(requestParameters: AnalyticsControllerGetMembersAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MembersAnalyticsResponseDto>;
    public analyticsControllerGetMembersAnalyticsV1(requestParameters: AnalyticsControllerGetMembersAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MembersAnalyticsResponseDto>>;
    public analyticsControllerGetMembersAnalyticsV1(requestParameters: AnalyticsControllerGetMembersAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MembersAnalyticsResponseDto>>;
    public analyticsControllerGetMembersAnalyticsV1(requestParameters: AnalyticsControllerGetMembersAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetMembersAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/members`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MembersAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the dashboard overview
     * Interpretation: members means new signups in the selected period, not total membership. active_passes means active customers at the requested cutoff, not the live current counter. Campaign CTR uses period-level unique customer/campaign counts. Its series assigns each click to the latest preceding delivery to that customer for that campaign, using the delivery bucket in X-APP-TIMEZONE. Both the click and the delivery must fall within the requested period. Each customer counts once per campaign per delivery bucket; clicks without a matching delivery are omitted from the series but may count in the KPI when the campaign has period deliveries. Summing series counts or averaging bucket rates does not reproduce the KPI. Balances and rates must not be summed across dates.  Combines active customers, webapp conversion and campaign CTR. The active_passes metric counts customers with at least one active store card at each cutoff, unifying devices and wallets; it uses series.activeCustomers rather than summing Apple and Google. Anonymous campaigns are excluded from campaign metrics. Coupon passes are excluded from active-customer metrics. Campaign sent counts use sent_at (device delivery), excluding undelivered notifications.  With JeriCommerce loyalty enabled, also returns new members, net member revenue and redemption rate. Otherwise those metrics are omitted and loyaltyEnabled&#x3D;false. Rates are fractions and revenue uses major units of program currency. KPI and chart previous values follow compare; chart values are aligned by bucket position.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.  Known limitation: the redemption-rate metric inherits incomplete reward-refund attribution from points analytics; it may not fully reflect returned points.
     * @endpoint get /v1/analytics/{programId}/overview
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetOverviewAnalyticsV1(requestParameters: AnalyticsControllerGetOverviewAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<OverviewAnalyticsResponseDto>;
    public analyticsControllerGetOverviewAnalyticsV1(requestParameters: AnalyticsControllerGetOverviewAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OverviewAnalyticsResponseDto>>;
    public analyticsControllerGetOverviewAnalyticsV1(requestParameters: AnalyticsControllerGetOverviewAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OverviewAnalyticsResponseDto>>;
    public analyticsControllerGetOverviewAnalyticsV1(requestParameters: AnalyticsControllerGetOverviewAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetOverviewAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/overview`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<OverviewAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get customer installations, uninstalls and active customers
     * Interpretation: these are customer activation/deactivation events, not unique first-ever installers in the selected period. Repeated activation cycles can count more than once. Monthly churn is normalized activity, not a probability, and can exceed 100%. Live current counters and historical end-of-period KPIs answer different questions.  Includes store cards belonging to a customer; coupon passes and customerless passes are excluded. All passes and devices are unified per customer: an installation occurs when the customer goes from no installed store card to at least one; an uninstall occurs only when the last one is removed. A later reinstall starts a new activation. Additional devices or wallets do not add global installations.  current.installed and current.uninstalled are queried live from pass status on every request, independently of the requested dates. A customer is uninstalled only if they have an Uninstalled store card and no Installed store card; customers with only never-installed cards are excluded.  Period KPIs and series use lifecycle history. activePasses is an alias of activeCustomers, both counting unique customers at the period end. series.activeCustomers is the cross-wallet total; Apple/Google values and byWallet deduplicate within each wallet and can overlap. Do not add wallets to obtain the total. Churn is customer deactivations divided by active customers at the period start, scaled to 30 days. Rates are fractions (0.1 means 10%) and zero for a zero denominator. Previous values follow compare.  Historical state uses events and timestamp fallbacks. Legacy Apple device-level uninstall events without remaining-device information cannot always reconstruct the exact historical state.  Period KPIs and charts may be cached for five minutes; current counters are not cached. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/passes
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetPassesAnalyticsV1(requestParameters: AnalyticsControllerGetPassesAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PassesAnalyticsResponseDto>;
    public analyticsControllerGetPassesAnalyticsV1(requestParameters: AnalyticsControllerGetPassesAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PassesAnalyticsResponseDto>>;
    public analyticsControllerGetPassesAnalyticsV1(requestParameters: AnalyticsControllerGetPassesAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PassesAnalyticsResponseDto>>;
    public analyticsControllerGetPassesAnalyticsV1(requestParameters: AnalyticsControllerGetPassesAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetPassesAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/passes`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PassesAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get loyalty balance and point movements
     * Interpretation: redemption rate can exceed 100% or be negative because earning, spending and refunds occur in different periods. Valuation uses dynamic codes\&#39; discount_value or fixed rewards\&#39; fixed-discount batch value, proportionally to identified point movements. Percentage discounts and missing monetary values are not valued. Estimated cost extrapolates from this valuatable subset; it is not realized discount expense, margin cost or an accounting liability. Stored coupon monetary values are used without currency conversion here.  Returns earned, redeemed and removed amounts, net redemption event counts, outstanding balance at the period end, a time series and channel breakdown. Historical balance is reconstructed from current balances by reversing later point movements. Earned excludes reward-refund credits; reward-linked point movements contribute to net redeemed amounts.  Redemptions count REWARD_REDEEMED events, including free redemptions. Partial refunds do not cancel a redemption. An identified explicit cancellation or cumulative identified credits restoring all spent points cancels that cycle only once. Cancellations are dated when they first become complete; a period can be negative when cancelling earlier redemptions. Reusing a code starts a new cycle. Unmatched cancellations are ignored; historical debits without a redemption event cannot supply a redemption count.  Balances and movements are always in points (balanceType&#x3D;points), independent of tier qualification units. Redemption rate is redeemed/earned as a fraction, or zero when earned is zero. Estimated cost values the outstanding points using the period\&#39;s net monetary reward value per net valued point; it is null when net valued points are not positive. KPI previous values follow compare. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.  Known limitation: reward refunds are not fully reflected. Credits linked to a reward are deducted, but refunds missing reward identity can leave redeemed points and estimated cost overstated. Do not interpret these metrics as fully reconciled net-of-refund totals.
     * @endpoint get /v1/analytics/{programId}/points
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetPointsAnalyticsV1(requestParameters: AnalyticsControllerGetPointsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PointsAnalyticsResponseDto>;
    public analyticsControllerGetPointsAnalyticsV1(requestParameters: AnalyticsControllerGetPointsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PointsAnalyticsResponseDto>>;
    public analyticsControllerGetPointsAnalyticsV1(requestParameters: AnalyticsControllerGetPointsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PointsAnalyticsResponseDto>>;
    public analyticsControllerGetPointsAnalyticsV1(requestParameters: AnalyticsControllerGetPointsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetPointsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/points`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PointsAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get processed customer revenue and orders
     * Interpretation: program customer revenue does not establish incremental sales caused by loyalty. Refunds are recognized on the refund transaction date and may relate to earlier purchases; net revenue can therefore be negative. Orders count transaction records rather than distinct order IDs. AOV uses gross purchase amounts before refunds; amounts are used as recorded, with no separate tax/shipping adjustment.  Includes processed transactions for program customers by transaction created_at. Purchases have no return_id; refunds have return_id. Internal Shopify order-ownership correction refunds are excluded. Net revenue is gross revenue minus refunds; orders counts purchase transactions; AOV is gross revenue/orders, or zero without orders.  Amounts are in major units of the program currency (for example 12.50 EUR), with currency conversion by local transaction day. Returns KPIs and a zero-filled time series; previous values follow compare. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/revenue
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetRevenueAnalyticsV1(requestParameters: AnalyticsControllerGetRevenueAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RevenueAnalyticsResponseDto>;
    public analyticsControllerGetRevenueAnalyticsV1(requestParameters: AnalyticsControllerGetRevenueAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RevenueAnalyticsResponseDto>>;
    public analyticsControllerGetRevenueAnalyticsV1(requestParameters: AnalyticsControllerGetRevenueAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RevenueAnalyticsResponseDto>>;
    public analyticsControllerGetRevenueAnalyticsV1(requestParameters: AnalyticsControllerGetRevenueAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetRevenueAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/revenue`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RevenueAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get reward redemptions, usage and availability
     * Interpretation: estimatedCost is the net nominal value of valuatable reward movements, not realized expense or merchant margin cost. Dynamic discount_value and fixed-discount batch values are used; percentage discounts and unknown values are omitted. A non-null result may be partial; no coverage indicator is returned, and no currency conversion is applied to stored coupon values here. usedInOrderRate uses the code\&#39;s current transaction linkage without checking transaction date/status; it is not a reconstructed historical usage rate. Do not label null estimatedCost as zero cost or null on-demand availability as out of stock.  Returns net reward-linked point activity, estimated cost, net redemption counts and series, and coupon availability. usedInOrderRate is the fraction of redemptions made in the period that remain uncancelled at to_date whose codes are currently linked to an order. shareOfRedemptions is this reward\&#39;s share of those uncancelled period redemptions across the program. Both fractions are zero when their denominator is zero; cancellations of earlier-period redemptions do not reduce these denominators.  Redemptions count REWARD_REDEEMED events, including free redemptions. Partial refunds do not cancel a redemption. An identified explicit cancellation or cumulative identified credits restoring all spent points cancels that cycle only once. Cancellations are dated when they first become complete; a period can be negative when cancelling earlier redemptions. Reusing a code starts a new cycle. Unmatched cancellations are ignored; historical debits without a redemption event cannot supply a redemption count.  pointsUsed is always in points. Estimated cost uses the monetary value of rewards, independent of tier qualification units, and is null when valuation is unavailable. Availability is a current snapshot of unclaimed, unexpired codes, independent of the requested date range; it is null for on-demand generation. KPI and series previous values follow compare. Requires JeriCommerce loyalty (HTTP 403); missing or other-program rewards return HTTP 404.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.  Known limitation: reward refunds are not fully reflected. Refund credits without reward identity may be omitted from this detail, affecting redeemed points and estimated cost. Refund handling is currently partial.
     * @endpoint get /v1/analytics/{programId}/rewards/{rewardId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetRewardDetailAnalyticsV1(requestParameters: AnalyticsControllerGetRewardDetailAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RewardDetailAnalyticsResponseDto>;
    public analyticsControllerGetRewardDetailAnalyticsV1(requestParameters: AnalyticsControllerGetRewardDetailAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RewardDetailAnalyticsResponseDto>>;
    public analyticsControllerGetRewardDetailAnalyticsV1(requestParameters: AnalyticsControllerGetRewardDetailAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RewardDetailAnalyticsResponseDto>>;
    public analyticsControllerGetRewardDetailAnalyticsV1(requestParameters: AnalyticsControllerGetRewardDetailAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetRewardDetailAnalyticsV1.');
        }
        const rewardId = requestParameters?.rewardId;
        if (rewardId === null || rewardId === undefined) {
            throw new Error('Required parameter rewardId was null or undefined when calling analyticsControllerGetRewardDetailAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rewards/${this.configuration.encodeParam({name: "rewardId", value: rewardId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RewardDetailAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the top rewards by net redemption activity
     * Interpretation: estimatedCost sums known nominal discount values, not realized expense or merchant margin cost. Dynamic code discount_value and fixed-discount batch values can be valued; percentage discounts and missing values cannot. A non-null amount can be a partial total when only some activity is valuatable; no coverage indicator is returned. Coupon monetary values are used as stored, without currency conversion here. Null must not be displayed as zero cost.  Returns at most 10 rewards with redemption activity or reward-linked point movements in the requested period, ordered by net redemption count. pointsUsed and estimatedCost net the identified point debits and credits independently of the redemption count.  Redemptions count REWARD_REDEEMED events, including free redemptions. Partial refunds do not cancel a redemption. An identified explicit cancellation or cumulative identified credits restoring all spent points cancels that cycle only once. Cancellations are dated when they first become complete; a period can be negative when cancelling earlier redemptions. Reusing a code starts a new cycle. Unmatched cancellations are ignored; historical debits without a redemption event cannot supply a redemption count.  Fixed rewards expose redeemCost; dynamic rewards return null there. Estimated monetary cost is null when reward valuation is unavailable. This ranking has no comparison values or time series; compare and granularity are accepted and validated but do not change its rows. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.  Known limitation: reward refunds are not fully reflected. Refund credits without reward identity cannot be attributed to these rows, so pointsUsed and estimatedCost may remain overstated. Refund handling is currently partial.
     * @endpoint get /v1/analytics/{programId}/rewards
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetRewardsAnalyticsV1(requestParameters: AnalyticsControllerGetRewardsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RewardsAnalyticsResponseDto>;
    public analyticsControllerGetRewardsAnalyticsV1(requestParameters: AnalyticsControllerGetRewardsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RewardsAnalyticsResponseDto>>;
    public analyticsControllerGetRewardsAnalyticsV1(requestParameters: AnalyticsControllerGetRewardsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RewardsAnalyticsResponseDto>>;
    public analyticsControllerGetRewardsAnalyticsV1(requestParameters: AnalyticsControllerGetRewardsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetRewardsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rewards`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RewardsAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get current customer segment sizes
     * Interpretation: these are descriptive audience rules, not churn predictions or mutually exclusive customer states. pass_uninstalled uses pass timestamp columns to detect current installation, not the live status-based current counters or full lifecycle reconstruction used by /passes; results can differ. A customer\&#39;s reward affordability does not establish that they intend to redeem.  Returns current counts for predefined customer segments. This endpoint does not accept date, granularity or comparison filters, and does not use X-APP-TIMEZONE. Windows are relative to database now(). at_risk requires at least three processed non-return purchases in the last 12 months and no such purchase in the last 120 days. pass_uninstalled requires a store-card uninstall in the last 30 days and no currently installed store-card pass.  With JeriCommerce loyalty, high_balance_no_redeem includes customers who can afford an available reward and have no REWARD_REDEEMED event in the last 90 days. With active tier cycles, near_next_tier includes customers at 90% or more of the next threshold, below that threshold. Segments can overlap. Results may be cached for five minutes.
     * @endpoint get /v1/analytics/{programId}/segments
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetSegmentsAnalyticsV1(requestParameters: AnalyticsControllerGetSegmentsAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AnalyticsSegmentDto>>;
    public analyticsControllerGetSegmentsAnalyticsV1(requestParameters: AnalyticsControllerGetSegmentsAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AnalyticsSegmentDto>>>;
    public analyticsControllerGetSegmentsAnalyticsV1(requestParameters: AnalyticsControllerGetSegmentsAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AnalyticsSegmentDto>>>;
    public analyticsControllerGetSegmentsAnalyticsV1(requestParameters: AnalyticsControllerGetSegmentsAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetSegmentsAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;

        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/segments`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AnalyticsSegmentDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get current tier distribution and period spending
     * Interpretation: avgSpendPerMember is net period spending per current member, not lifetime value. aov is gross period purchases divided by purchase transaction count; avgOrdersPerMember includes non-buyers. Balances are spendable points, while requiredPoints is a tier qualification threshold. Tier revenue shares need not total 100% because members without a tier are included in the denominator.  Member counts, tier assignments and loyalty balances are current snapshots, not historical state at to_date. Spending metrics use processed transactions in the selected period, grouped by each customer\&#39;s current tier. Members without a tier are reported separately.  Revenue is net of refunds in major units of program currency; internal Shopify order-ownership correction refunds are excluded. Revenue share is a fraction of all program net revenue in the period, including customers without a tier. Disabled tier cycles or no configured tiers return tiersEnabled&#x3D;false and an empty tiers array. No comparison series is returned. Requires JeriCommerce loyalty; otherwise HTTP 403.  Results may be cached for five minutes. Date ranges are inclusive; see the date, granularity and compare parameters for defaults and limits.
     * @endpoint get /v1/analytics/{programId}/tiers
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public analyticsControllerGetTiersAnalyticsV1(requestParameters: AnalyticsControllerGetTiersAnalyticsV1RequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TiersAnalyticsResponseDto>;
    public analyticsControllerGetTiersAnalyticsV1(requestParameters: AnalyticsControllerGetTiersAnalyticsV1RequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TiersAnalyticsResponseDto>>;
    public analyticsControllerGetTiersAnalyticsV1(requestParameters: AnalyticsControllerGetTiersAnalyticsV1RequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TiersAnalyticsResponseDto>>;
    public analyticsControllerGetTiersAnalyticsV1(requestParameters: AnalyticsControllerGetTiersAnalyticsV1RequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const programId = requestParameters?.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling analyticsControllerGetTiersAnalyticsV1.');
        }
        const xAPPTIMEZONE = requestParameters?.xAPPTIMEZONE;
        const fromDate = requestParameters?.fromDate;
        const toDate = requestParameters?.toDate;
        const granularity = requestParameters?.granularity;
        const compare = requestParameters?.compare;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'from_date',
            <any>fromDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'to_date',
            <any>toDate,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'granularity',
            <any>granularity,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'compare',
            <any>compare,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (xAPPTIMEZONE !== undefined && xAPPTIMEZONE !== null) {
            localVarHeaders = localVarHeaders.set('X-APP-TIMEZONE', String(xAPPTIMEZONE));
        }

        // authentication (bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/analytics/${this.configuration.encodeParam({name: "programId", value: programId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/tiers`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TiersAnalyticsResponseDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
